export const VARIANT_SELECT_MODES = {
  DEFAULT: 'default',
  ABM: 'abm'
};
// The Select default is 8, which is too high for ABM strategies where users switch
// between CRM object (company or contact) targeted variants and need to find an account quickly.
export const ABM_MINIMUM_SEARCH_COUNT = 3;